import { useSelector } from 'react-redux';
import { useUpdateUserProfile } from '../../../../queries/profile';
import ProfileForm from './ProfileForm';

function UserProfile() {
    const companyDetails = useSelector((state) => state.global.companyDetails);
    const updateUserProfile = useUpdateUserProfile();

    const userInfo = {
        name: companyDetails?.user?.name,
        email: companyDetails?.user?.email,
    };

    const submitHandler = async (data) => {
        await updateUserProfile.mutateAsync({ name: data.name });
    };

    return (
        <ProfileForm
            profileType="user"
            submitHandler={submitHandler}
            data={userInfo}
            showImagePicker={false}
            showPhone={false}
        />
    );
}

export default UserProfile;
